export class GroupUserEdit extends HTMLElement {
  constructor(data, group_id, is_admin) {
    super();
    this.data = data
    this.group_id = group_id
    this.is_admin = is_admin
    this.roles = data.auto_group_roles.filter(role => role.auto_group_id == group_id)
    this.current_role_ids = data.auto_group_roles.reduce((res, auto_group_role) => auto_group_role.auto_group_id == group_id ? res.push(auto_group_role.group_role_name_id) && res : res, [])
    this.user_profile = data.user_profile
    this.email = data.email
    this.teams = [...data.teams]
    this.current_team_ids = data.teams.reduce((res, team) => team.group_id == group_id ? res.push(team.team_id) && res : res, [])
    this.new_roles = []
    this.new_teams = []
    this.is_rep
  }
  connectedCallback() {
    this.is_rep = this.roles.filter(role => role.group_role_name_id == 8).length > 0;
    let current_roles = this.roles.map(role => `<div class='badge badge-pill badge-info'>${role.group_role_display_name} <span class="fas fa-times remove-user-role" data-id="${role.group_role_name_id}"></span></div>`).join('')
    let current_teams = this.teams.filter((team) => this.group_id == team.group_id).map(team => `<div class='badge badge-pill badge-info'>${team.name} <span class="fas fa-times remove-user-team" data-id="${team.team_id}"></span></div>`).join('')
    let employee_code = this.current_role_ids.includes(8) ? this.data.auto_group_roles.filter(role => role.group_role_name_id == 8)[0].employee_code : '';
    this.innerHTML = 
    `<style>
      #edit-user-back {
        font-family: "FontAwesome";
        font-weight: normal;
      }

      #edit-user-back:hover {
        cursor: pointer;
      }

      #edit-group-user {
        width: 75%;
        margin: 0 auto;
      }

      .edit-user-pills {
        margin-bottom: 5px;
      }

      group-user-edit h5 {
        margin-bottom: 20px;
      }
      
      .edit-user-buttons {
        margin-top: 20px;
      }

      .edit-user-div {
        margin: 20px 0;
      }

      group-user-edit .badge {
        margin: 3px 5px 3px 0;
      }

      group-user-edit .fas {
        font-family: FontAwesome;
      }

      group-user-edit .fa-times:hover {
        cursor: pointer;
      }

      group-user-edit h4 {
        font-weight: 600;
      }

      .rep_code_name_container div:first-child {
        padding-right: 10px !important;
      }

      .rep_code_name_container div:nth-child(2) {
        padding-left: 10px !important;
      }
    </style>
    <div class="" id="edit-group-user">
      <h3><span id="edit-user-back" class="fas fa-chevron-left"></span> Edit User</h3>
      <div class="errors"></div>
      <div class="">
        <h4>User: ${!this.is_admin && this.user_profile.first_name && this.user_profile.last_name ? `${this.user_profile.first_name} ${this.user_profile.last_name}` : `${this.email}`}</h4>
        ${this.is_admin && this.is_rep ? 
          `
          <div class="row" rep_name_edit>
            <div class="col-md-6 no-gutters" style="padding-right:20px !important">
              <input type="text" class="form-control" id="rep_first_name_edit" placeholder="First Name" value="${this.user_profile.first_name ? `${this.user_profile.first_name}` : `${this.email}`}">
            </div>
            <div class="col-md-6 no-gutters">
              <input type="text" class="form-control" id="rep_last_name_edit" placeholder="Last Name" value="${this.user_profile.last_name ? `${this.user_profile.last_name}` : ``}">
            </div>
          </div>
          ` : ''}
        <div class="edit-user-div edit-user-role">
          <h4>Current Roles</h4>
          <div class="edit-user-pills">
            ${current_roles}
          </div>
          <select is="group-role-select" id="edit-role-select" class="form-control"></select>
        </div>
        <div class="edit-user-div edit-user-team ${this.roles.some(e => e.group_role_name == 'messaging_agent' || e.group_role_name == 'message_agent_with_outbound') ? '' : 'hidden'}">
          <h4>Current Teams</h4>
          <div class="edit-user-pills">
            ${current_teams.length > 0 ? current_teams : '<span style="color:red">Messaging Agents not assigned to a team cannot use Message Center</span>'}
          </div>
          <select is="teams-select" id='edit-team-select' for_groups='true' class='form-control'></select>
        </div>
        ${(this.current_role_ids.includes(8) || this.new_roles.some(e => e.role_id == 8)) && !this.new_roles.some(e => e.role_id == 8 && e.action == "DELETE") && !this.is_admin ? 
        `<div class="edit-user-div">
          <h4>Rep Code</h4>
          <input type="text" class="form-control" id="rep_code_edit" placeholder="3-6 digits" minlength="3" maxlength="6" value="${employee_code}">
        </div>
        ${this.data.user_profile.first_name && this.data.user_profile.last_name ? '' :
        `<div class="edit-user-div row rep_code_name_container">
          <div class="col-sm-6 no-gutters">
            <h4>First Name</h4>
            <input type="text" class="form-control" id="rep_code_first_name" value="${this.data.user_profile.first_name ? this.data.user_profile.first_name : ''}">
          </div>
          <div class="col-sm-6 no-gutters">
            <h4>Last Name</h4>
            <input type="text" class="form-control" id="rep_code_last_name" value="${this.data.user_profile.last_name ? this.data.user_profile.last_name : ''}">
          </div>
        </div>`
        }` : ''}
        <div class="edit-user-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-user-edit">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
    </div>`;

    this.querySelector('#edit-user-back').addEventListener('click', function() {
      this.cancelEdit();
    }.bind(this))
    
    this.querySelector('.cancel').addEventListener('click', function() {
      this.cancelEdit();
    }.bind(this))

    this.querySelector('.save').addEventListener('click', function() {
      this.save();
    }.bind(this))

    this.querySelector('#edit-role-select').onchange = (e) => {this.addRole(e.target, e.target.value)}

    this.querySelector('#edit-team-select').onchange = (e) => {this.addTeam(e.target, e.target.value)}

    this.querySelectorAll('.remove-user-role').forEach(button => {
      button.addEventListener('click', function(e) {
        this.removeRole(e.target.dataset.id)
      }.bind(this));
    })

    this.querySelectorAll('.remove-user-team').forEach(button => {
      button.addEventListener('click', function(e) {
        this.removeTeam(e.target.dataset.id)
      }.bind(this));
    })
  }

  cancelEdit() {
    this.remove();
    document.querySelector('group-users').show();
  }

  addRole(target, id) {
    let roleID = parseInt(id);
    if(roleID && !this.roles.some(e => e.group_role_name_id == roleID)) {
      this.roles.push({group_role_name: target.getCurrentName(),group_role_display_name: target.options[target.selectedIndex].text, group_role_name_id: roleID});
      this.new_roles = this.new_roles.filter(role => role.role_id != roleID)
      if(!this.current_role_ids.includes(roleID)) {
        this.new_roles.push({role_id: roleID, action: "ADD"})
      }
      this.connectedCallback();
    }
  }

  addTeam(name, id) {
    let teamID = parseInt(id);
    if(teamID && !this.teams.some(e => e.team_id == teamID)) {
      this.teams.push({name: name.options[name.selectedIndex].text, team_id: teamID, group_id: this.group_id});
      this.new_teams = this.new_teams.filter(team => team.team_id != teamID)
      if(!this.current_team_ids.includes(teamID)) {
        this.new_teams.push({team_id: teamID, action: "ADD"});
      }
      this.connectedCallback();
    }
  }

  removeRole(id) {
    if(this.roles.length === 1) {
      Common.notify('User must have a role.', 'danger')
      return
    }
    let roleID = parseInt(id);
    this.roles = this.roles.filter(role => role.group_role_name_id != roleID);
    this.new_roles = this.new_roles.filter(role => role.role_id != roleID);
    if(this.current_role_ids.includes(roleID)) {
      this.new_roles.push({role_id: roleID, action: "DELETE"})
    }
    this.connectedCallback();
  }

  removeTeam(id) {
    let teamID = parseInt(id);
    this.teams = this.teams.filter(team => team.team_id != teamID);
    this.new_teams = this.new_teams.filter(team => team.team_id != teamID);
    if(this.current_team_ids.includes(teamID)) {
      this.new_teams.push({team_id: teamID, action: "DELETE"})
    }
    this.connectedCallback();
  }

  validate() {
    let is_valid = true
    let errors = "";

    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    if(this.is_rep) {
      if(this.is_admin) {
        if(!this.querySelector('#rep_first_name_edit').value.trim()) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Warning!</strong> Please provide a first name.
                      </div>`;
          this.querySelector('#rep_first_name_edit').classList.add('error')
          is_valid = false;
        }
        if(!this.querySelector('#rep_last_name_edit').value.trim()) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Warning!</strong> Please provide a last name.
                      </div>`;
          this.querySelector('#rep_last_name_edit').classList.add('error')
          is_valid = false;
        }
      }
      if(this.querySelector('.rep_code_name_container')) {
        if(!this.querySelector('#rep_code_first_name').value.trim()) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Warning!</strong> Please provide a first name.
                      </div>`;
          this.querySelector('#rep_code_first_name').classList.add('error')
          is_valid = false;
        }
        if(!this.querySelector('#rep_code_last_name').value.trim()) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Warning!</strong> Please provide a last name.
                      </div>`;
          this.querySelector('#rep_code_last_name').classList.add('error')
          is_valid = false;
        }
      }
      if(this.querySelector('#rep_code_edit')) {
        if(this.querySelector('#rep_code_edit').value.length < 3 || this.querySelector('#rep_code_edit').value.length > 6) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Warning!</strong> Rep Code must be between 3 and 6 digits.
                      </div>`;
          this.querySelector('#rep_code_edit').classList.add('error')
          is_valid = false;
        }
        if(!parseInt(this.querySelector('#rep_code_edit').value)) {
          errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Warning!</strong> Rep Code must be a number.
                      </div>`;
          this.querySelector('#rep_code_edit').classList.add('error')
          is_valid = false;
        }
      }
    }

    this.querySelector('.errors').innerHTML = errors;
    return is_valid
  }

  async save() {
    if(!this.validate()) {
      return
    }
    let userID = this.user_profile.user_id;
    let data = {user: this.data.id, auto_group_id: this.group_id, new_roles: this.new_roles, new_teams: this.new_teams};
    
    if(this.is_admin && this.is_rep) {
      data.representive_name = {
        first_name: this.querySelector('#rep_first_name_edit').value.trim(),
        last_name: this.querySelector('#rep_last_name_edit').value.trim()
      }
    }
    let representive_role = data.new_roles.filter((role) => role.role_id == 8 && role.action != "DELETE")
    if(representive_role.length > 0) {
      if(this.querySelector('.rep_code_name_container')) {
        representive_role[0].first_name = this.querySelector('#rep_code_first_name').value;
        representive_role[0].last_name = this.querySelector('#rep_code_last_name').value;  
      }
      representive_role[0].employee_code = this.querySelector('#rep_code_edit') ?  this.querySelector('#rep_code_edit').value : '';
    } else if(representive_role.length == 0 && data.new_roles.filter((role) => role.role_id == 8 && role.action == "DELETE").length == 0)    {
      representive_role = this.data.auto_group_roles.filter((role) => role.group_role_name_id == 8);
      if(representive_role.length > 0 && this.querySelector('#rep_code_edit') != null && this.querySelector('#rep_code_edit').value != representive_role[0].employee_code) {
        let update_role = {}
        update_role.role_id = 8;
        update_role.employee_code = this.querySelector('#rep_code_edit') ?  this.querySelector('#rep_code_edit').value : '';
        update_role.action = "EDIT";
        data.new_roles.push(update_role)
      }
    }

    if(this.querySelector('#rep_code_edit')) {
      data.employee_code = this.querySelector('#rep_code_edit').value;
    }

    if(this.roles.filter(role => role.group_role_name == "messaging_agent" || role.group_role_name == "message_agent_with_outbound").length > 0 && this.querySelectorAll('.edit-user-team .edit-user-pills .badge').length <= 0) {
      Common.notify('User must have a Team.', 'danger')
      return;
    }

    let result = await fetch(`/admin/users/${userID}/update_roles`, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    let response = await result.json();
    if(response.success) {
      Common.notify('User roles updated', 'success');
      this.cancelEdit();
      document.querySelector('group-users').reloadData();
    }
    else Common.notify(response.msg != null ? response.msg : 'Failed to update user', 'error');
  }
}

customElements.define('group-user-edit', GroupUserEdit)